import { Button } from '@platform/components';
import { HeaderFooterLayout } from '../../app';
import { BlogArticleSummary } from '../util/types';
import ArticlesGrid from './ArticlesGrid';
import DirectoryContainer from './DirectoryContainer';
import { TypeBlogCategory } from '@platform/contentful';
import MetaTags from '../../util/MetaTags';

/** Shows all the article summaries for a given category, or 'all' categories (all blog posts). */
export const CategoryDirectory = ({
  category,
  allCategories,
  articleSummaries,
}: {
  category?: TypeBlogCategory<'WITHOUT_UNRESOLVABLE_LINKS', 'en-US'>;
  allCategories: TypeBlogCategory<'WITHOUT_UNRESOLVABLE_LINKS', 'en-US'>[];
  articleSummaries: BlogArticleSummary[];
}) => {
  return (
    <HeaderFooterLayout>
      <MetaTags
        title={`MovingWorlds Blog - ${category?.fields.name ?? 'All'} Posts`}
        description="Inspiring stories and best practices about international volunteering - and how it's solving the talent gap."
        imageUrl='https://images.ctfassets.net/e6h4r2c2hknq/6DfpeDtNazPAYNfBc0v1jt/96bdd92367c4379ad66428f5cf4babfc/problem-solving-collaboratively-ux-indonesia-qC2n6RQU4Vw-unsplash-min.jpg'
      />
      <DirectoryContainer color='gray' negativeTopMargin>
        <div className='py-8 flex flex-col gap-8'>
          <h2 className='text-2xl text-gray-700'>{category?.fields.name ?? 'All'} Articles</h2>
          <div className='flex gap-2 flex-wrap'>
            {allCategories.map((c) => (
              <Button
                key={`${c.fields.name}-btn`}
                variant='primary'
                size='sm'
                href={`${import.meta.env['VITE_STATIC_FILES_URL']}/blog/category/${c.fields.slug}`}
              >
                {c.fields.name}
              </Button>
            ))}
          </div>
          <ArticlesGrid articles={articleSummaries} />
        </div>
      </DirectoryContainer>
    </HeaderFooterLayout>
  );
};
